import {
  EnquiryHandle,
  IServerSideGetRowsParams,
  ServerSideCriteria,
  useServerEnquiry,
} from '@access-erp/common';
import { useRef, useState } from 'react';

import { ContractsEnquiriesScreen } from '@/components/common/EnquiriesScreen/providers/ContractsEnquiriesScreen';
import { Forms } from '@/graphql/contracts/_generated_/contracts';
import { GetPaginatedFilteredClientDatabasesVariables } from
  '@/graphql/contracts/_generated_/getPaginatedFilteredClientDatabases.query';
import { CONTRACTS_PER_PAGE } from '@/config/common.config';
import { useColumns } from './hooks/useColumns';
import useGetClientDatabases from './hooks/useGetClientDatabases';
import { ClientDatabaseTypeWithId } from './types';
import { getSavedSearch } from '@/components/common/EnquiriesScreen/utils/savedSearch';

const ClientDatabasesComponent = () => {
  const [pageIsLoading, setPageIsLoading] = useState(true);
  const gridRef = useRef<EnquiryHandle<ClientDatabaseTypeWithId>>();
  const { headerColumns, goToClientDatabasesBySearch } = useColumns();
  const { getClientDatabases } = useGetClientDatabases();
  const enquiry = useServerEnquiry<
  ClientDatabaseTypeWithId,
  GetPaginatedFilteredClientDatabasesVariables['filter']
  >({
    gridRef: gridRef as any,
    headerColumns: headerColumns as any,
    initialFilter: [],
  });

  const searchTextFromQuery = getSavedSearch?.()?.savedSearch;

  const getData = async (
    params: IServerSideGetRowsParams,
    serverSideCriteria: ServerSideCriteria,
  ) => {
    const clientDatabasesData = await getClientDatabases({
      after: serverSideCriteria.nextPageCursor,
      first: CONTRACTS_PER_PAGE,
      filter: {
        summary: enquiry.serverSide?.current?.search ?? searchTextFromQuery,
        ...(enquiry.serverSide?.current?.customFilters ?? {}),
        ...serverSideCriteria.groupingFilters,
      },
      sort: serverSideCriteria.userSetSorting as any,
      group: serverSideCriteria.groupByColumn ?? undefined,
    });

    setPageIsLoading(false);

    const searchIsCleared = enquiry.serverSide?.current?.search === '';
    if (enquiry.serverSide?.current?.search || searchIsCleared) {
      goToClientDatabasesBySearch(enquiry.serverSide?.current?.search);
    }

    const clientDatabasesDataWithIds = clientDatabasesData?.items?.map((el: any) => ({
      ...el,
    }));

    return {
      items: clientDatabasesDataWithIds ?? [],
      pageInfo: {
        hasNextPage: clientDatabasesData?.pageInfo?.hasNextPage || false,
        hasPreviousPage: clientDatabasesData?.pageInfo?.hasPreviousPage || false,
        endCursor: clientDatabasesData?.pageInfo?.endCursor,
        startCursor: clientDatabasesData?.pageInfo?.startCursor,
      },
    };
  };

  return (
    <>
      <ContractsEnquiriesScreen
        ref={gridRef as any}
        enquiry={enquiry}
        filterForm={Forms.ClientDatabases}
        formName={Forms.ClientDatabases}
        headerProps={{
          primaryTitle: 'Client Databases',
          secondaryTitle: 'List',
          searchPlaceholder: 'Start typing Client Database ID or Name',
          showExportAll: true,
          showExportCurrent: false,
          disableSavedSearch: true,
        }}
        detailProps={{
          exportFileName: 'Client Databases',
          rowGroupPanelShow: 'always',
          masterDetail: true,
          getData: getData as any,
          pageSize: CONTRACTS_PER_PAGE,
          suppressRowClickSelection: false,
          loading: pageIsLoading,
          selectAllCheckbox: false,
          rowSelection: 'none',
        }}
      />
    </>
  );
};

export default ClientDatabasesComponent;
